import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { QRCodeSVG } from 'qrcode.react';

const DirectGuaranteePage = () => {
  const { orderId, itemId } = useParams();
  const [order, setOrder] = useState(null);
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/direct-orders/${orderId}`)
      .then(res => {
        setOrder(res.data);
        console.log("All item IDs:", res.data.items.map(i => i._id.toString()));
console.log("Item ID from URL:", itemId);

        const foundItem = res.data.items.find(i => i._id.toString() === itemId);
        setItem(foundItem);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [orderId, itemId]);

  if (loading) {
    return (
      <div className="max-w-xl mx-auto pt-20 p-6 bg-white shadow-lg text-sm rounded-lg border animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-4 mx-auto"></div>
        <div className="flex justify-center mb-6">
          <div className="w-32 h-32 bg-gray-200 rounded"></div>
        </div>
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
        <div className="h-20 bg-gray-100 rounded mb-6"></div>
        <div className="flex justify-center mt-4">
          <div className="w-28 h-28 bg-gray-200 rounded"></div>
        </div>
        <div className="mt-6 text-center">
          <div className="w-40 h-10 bg-gray-300 rounded mx-auto"></div>
        </div>
      </div>
    );
  }
    if (!order || !item) return <p className="p-6 text-red-600">Guarantee information not found.</p>;

  const expiry = dayjs(order.createdAt).add(1, 'year');
  const remainingDays = expiry.diff(dayjs(), 'day');

  return (
    <div className="max-w-xl mx-auto pt-20 p-6 bg-white shadow-lg text-sm rounded-lg border">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A5 portrait; margin: 0; }
          body { margin: 0; }
        }
      `}</style>
  
      <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">Product Guarantee Certificate</h2>
  
      {/* Product Image */}
      <div className="flex justify-center mb-4">
        <img
          src={`/uploads/${item.photo.replace(/\\/g, '/')}`}
          alt={item.name}
          className="w-32 h-32 object-cover rounded border hover:scale-105 transition-transform cursor-pointer"
          onClick={() => window.open(`/product/${item.customId}`, '_blank')}
        />
      </div>
  
      {/* Customer & Product Info */}
      <div className="grid grid-cols-2 gap-4 text-gray-700 mb-6">
        <div>
          <p><strong>Order ID:</strong> {order.orderId}</p>
          <p><strong>Customer:</strong> {order.customer.name}</p>
          <p><strong>Phone:</strong> {order.customer.phone}</p>
          <p><strong>Address:</strong> {order.customer.address}</p>
        </div>
        <div>
        <p><strong>Product ID:</strong> {item.customId || item.productId}</p>
        <p><strong>Name:</strong> {item.name}</p>
          <p><strong>Type:</strong> {item.productType?.join(', ') || '—'}</p>
          <p><strong>Weight:</strong> {item.weight}g</p>
          <p><strong>Price:</strong> ${parseFloat(item.price).toFixed(2)}</p>
          <p><strong>Karat:</strong> 21K</p>
        </div>
      </div>
  
      {/* Guarantee Badge */}
      <div className="bg-gray-100 border rounded p-4 mb-6 text-center">
        <h3 className="text-sm font-medium mb-2 text-gray-700">Guarantee Validity</h3>
        <p><strong>Valid Until:</strong> {expiry.format('YYYY-MM-DD')}</p>
        <p><strong>Remaining:</strong> {remainingDays} days</p>
      </div>
  
      {/* QR Code */}
      <div className="mt-6 mb-4 flex flex-col items-center justify-center">
  <QRCodeSVG value={window.location.href} size={100} />
  <p className="text-xs mt-2 text-gray-500 mt-2">Scan to verify online</p>
</div>
  
      <div className="text-center mt-6">
        <button
          onClick={() => window.print()}
          className="no-print bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          Print Guarantee Card
        </button>
      </div>
    </div>
  );
  
};

export default DirectGuaranteePage;
